import { Button } from "@/components/ui/button";
import { AnimatePresence } from "framer-motion";
import { Plus } from "lucide-react";
import { useState } from "react";
import { PartialApp } from "../../types/app.type";
import AddAPIKeyModal from "./AddAPIKeyModal";

interface Props {
  app: PartialApp;
}

function AddAPIKey({ app }: Props) {
  const [addOpen, setAddOpen] = useState(false);

  return (
    <>
      <Button
        onClick={() => setAddOpen(true)}
        className="flex items-center gap-1 mr-0 ml-auto w-fit"
      >
        Add API key <Plus size={16} />
      </Button>
      <AnimatePresence>
        {addOpen && <AddAPIKeyModal app={app} setOpen={setAddOpen} />}
      </AnimatePresence>
    </>
  );
}

export default AddAPIKey;
